import GenericView from 'js/views/generic.view';
import Template from 'js/templates/voucher.redeem.hbs';
import i18n from 'l10n';
import UserModel from 'js/models/userrelatedinfo.model';
import Handlebars from 'handlebars';
import SubscriberTopPartPartial from 'js/templates/partials/subscriber.page.top.part.partial.hbs';
import {template, tagName, on, el} from "../adapters/backbone-decorators";

require('interfaceAdapter');
const subscriberInfoTemplate = Handlebars.compile(SubscriberTopPartPartial);

@template(Template)
@tagName('span')
@el("#edit-voucher")
class VoucherRedeemView extends GenericView {

    constructor(options) {
        super(options);
        if (options) this.code = options.code;
        this.userModel = new UserModel();
        this.userModel.fetch().done(() => {
            this.render();
        });

    }

    render() {
        const isPostpaid = this.userModel.postpaid;
        const code = this.code;
        const templateOutput = this.template({isPostpaid, code});
        this.$el.html(templateOutput);
    }

    @on('keypress .voucher-code')
    voucherCodeKeyPresses(ev) {
        var key = ev.which;
        if (key === 13) {
            this.redeemVoucher();
            return false;
        }
        return true;
    }

    @on('click .redeem')
    async redeemVoucher() {
        var code = this.$(".voucher-code").val();

        if (!code) {
            return;
        }

        var points = this.$(".voucher-points").val();

        const $redemptionMessage = this.$(".voucher-message");
        try {
            const data = await $.ajaxDefaultQ({
                url: `/CampaignCloud/RedeemVoucher?code=${encodeURIComponent(code)}&points=${encodeURIComponent(points)}`,
                type: 'GET',
                contentType: "application/json",
                dataType: 'json'
            }).then(function(data, status, xhr){
                if (xhr.status===204) return $.Deferred().resolve({status:"INVALID"}, status, xhr).promise(); else return $.Deferred().resolve(data, status, xhr).promise()
            });
            console.log(data);
            this.$(".voucher-code").val("");
            this.$(".voucher-points").val("");
            $redemptionMessage.removeClass("fg-zanteBlue fg-ripeSquash fg-grayLight fg-marineGreen");
            if (!data || !data.status) return;
            let newPoints = "";
            if (data.subscription && data.number === data.maxPoints) {
                newPoints = data.subscription.pointsBalance + parseInt(points) - data.number;
            }

            const messages = {
                "NO_MESSAGE": {
                    clName: "fg-zanteBlue",
                    message: points ? i18n.t("voucher.redeempointsnomessage", {
                            count: Number(points),
                            message: data.message || "",
                            number: data.number
                        })
                        : i18n.t("voucher.noredeemmessage", {
                            number: data.number,
                            suffix: i18n.ordinalSuffix(data.number)
                        })
                },
                "ALREADY_REDEEMED": {
                    clName: "fg-ripeSquash",
                    message: i18n.t("voucher.alreadyredeemedmessage")
                },
                "NOT_FOUND": {
                    clName: "fg-white",
                    message: i18n.t("voucher.notfoundredeemmessage")
                },
                "INVALID": {
                    clName: "fg-white",
                    message: i18n.t("voucher.novalidredeemmessage")
                },
                "REDEMPTION_BLOCKED": {
                    clName: "fg-white",
                    message: i18n.t("voucher.seasonTicketAlreadyScanned")
                },
                "MESSAGE": {
                    clName: "fg-marineGreen",
                    message: points ? i18n.t("voucher.redeempointsmessage", {
                            count: Number(points),
                            message: data.message || "",
                            number: data.number,
                            points: newPoints
                        })
                        : i18n.t("voucher.redeemmessage", {
                            message: data.message || "",
                            number: data.number,
                            suffix: i18n.ordinalSuffix(data.number)
                        })
                }
            };
            const {clName, message} = messages[data.status];
            $redemptionMessage.addClass(clName)
                .html(message);
            if (data.subscription) {
                const caption = `<h3 class="fg-white">${i18n.t('voucher.cardbelongsto')}</h3>`;
                this.$(".display-subscriber")
                    .html(caption + subscriberInfoTemplate(Object.assign({fromRedemption: true}, data.subscription)));
            }

        } catch (e) {
            this.$(".display-subscriber").empty();

            if (e.status === 400) {
                const {error, voucherType, max, numberFormat} = e.responseJSON;
                var text;
                switch (error) {
                    case "INVALID_TYPE":
                        text = i18n.t("voucher.invalidtype" + voucherType);
                        if (voucherType === "classic") {
                            this.$(".voucher-code").val("");
                        }
                        break;
                    case "NUMBER_FORMAT":
                        text = i18n.t("voucher.numberformat");
                        break;
                    case "MAX_EXCEEDED":
                        text = i18n.t("voucher.maxExceeded", {max});
                        this.$(".voucher-points").val(max);
                        break;
                    default:
                        text = i18n.t("voucher.novalidredeemmessage");
                        this.$(".voucher-code").val("");
                        break;
                }
                $redemptionMessage.text(text);
            } else if(e.status === 504) {
                $redemptionMessage.addClass("fg-white").text(i18n.t("voucher.notfoundredeemmessage"));
            } else {
                this.$(".voucher-code").val("");
                console.log(e);
            }
        }
    }
}

// Returning instantiated views can be quite useful for having "state"
export default VoucherRedeemView;
